@if (config) {
  <div class="highlight">
    <div class="chart"
       [ngClass]="{
          'multi-column': metadata.elements.length > 2, 
          'single-column': metadata.elements.length == 1, 
          'with-border': metadata.elements.length >= 2,
          'four-column': metadata.elements.length == 4
        }">
      @for (item of metadata.elements; track item; let i = $index) {
        <div class="element">
          <div class="split-item-group">
            <span class="quantity">{{ formatData(item.quantity, "number") }}</span>
            @if (metadata.elements.length <= 2) {
              <span class="concept"
                [matTooltip]="item.concept">
                {{ item.concept | truncate:getTruncateLimit(item, i) }}
              </span>
            }
          </div>
          @if (item.information) {
            <span class="information"
              [ngClass]="item?.positive ? 'positive-information' : 'negative-information'">
              {{ item.information }}
            </span>
          }
          @if (metadata.elements.length > 2) {
            <span class="concept"
              [matTooltip]="item.concept">
              {{ item.concept | truncate:getTruncateLimit(item, i) }}
            </span>
          }
        </div>
      }
    </div>
  </div>
}